import {
  Box,
  Chip,
  Dialog,
  DialogContent,
  Modal,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import Loading from "../../../../../UI/Loading/Loading";

const FunctionDeleteModal = ({ open, funcData, onClose, refresh }) => {
  const [loading, setLoading] = useState(false);

  const deleteBtnHandler = async (e) => {
    e.preventDefault();
    setLoading(true);

    let data = {
      id: funcData.id,
      language: funcData.language,
      uri: funcData.uri,
    };

    let url = "https://rawdat.ai/login/portal/delete-function";
    const formData = JSON.stringify(data);

    const response = await fetch(url, {
      method: "DELETE",
      body: formData,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const response_data = await response.text();

    if (response_data) {
      setLoading(false);
      refresh();
      onClose();
    }
  };

  if (!funcData) {
    return "Loading....";
  }

  return (
    <>
      <Dialog open={open} maxWidth={"xs"} fullWidth onClose={onClose}>
        <DialogContent>
          <Box display={"flex"} flexDirection={"column"} gap={"1.5rem"}>
            <Loading
              open={loading}
              closeLoading={() => setLoading(false)}
              title={"Deleting the function"}
            />
            <Typography>Delete this function ?</Typography>
            <Box display={"flex"} gap={"1rem"}>
              <Chip
                label={"Cancel"}
                variant="outlined"
                color="primary"
                onClick={onClose}
              />
              <Chip
                label={"Delete"}
                variant="filled"
                color="primary"
                onClick={deleteBtnHandler}
              />
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default FunctionDeleteModal;
